export default __webpack_public_path__ + "static/media/sign-out-mobile.4310ab15.svg";